angular.module('tgaApp').service('authService', [
  'localStorageService',
  function (localStorageService) {
    const storageKey = 'authentication';

    let authentication = {
      isAuth: false,
      token: null,
      userId: null,
    };

    function clearAuthentication() {
      authentication = {
        isAuth: false,
        token: null,
        userId: null,
      };
      localStorageService.remove(storageKey);
      return authentication;
    }

    function getAuthentication() {
      // Check cache
      if (authentication && authentication.isAuth) {
        return authentication;
      }

      authentication = localStorageService.get(storageKey);

      if (!authentication) {
        // Try session storage
        localStorageService.setStorageType('sessionStorage');
        authentication = localStorageService.get(storageKey);
      }

      if (!authentication || !authentication.isAuth) {
        clearAuthentication();
      }

      return authentication;
    }

    function setAuthentication(auth, remember) {
      authentication = auth;

      if (remember) {
        localStorageService.setStorageType('localStorage');
      } else {
        localStorageService.setStorageType('sessionStorage');
      }

      localStorageService.set(storageKey, authentication);
    }

    return {
      getAuthentication,
      setAuthentication,
      clearAuthentication,
    };
  },
]);
